import { COMMON_PAGE_TEXT } from '../../components/lang';

export const PAGE_TEXT = {
  ...COMMON_PAGE_TEXT,
  OK: 'OK',
  UPDATE: 'Update',
  MOVE_NEXT: 'Go to next step.',
  NEXT: 'Next Step',
  CLOSE: 'Close',
  PREVIEW_DIALOG: {
    TITLE: 'Preview',
    CONTENT:
      'Please note that this is a returned DoRPgS assessment. Kindly review the associated remarks, make the necessary assessment to your nomination, and resubmit it.',
  },
  MY_ASSESSMENTS: {
    TITLE: 'Assessments',
  },
  APPLICATION_LIST: {
    TITLE: 'List of Applications',
  },
  NON_PROPOSED: {
    TITLE: 'Non-proposed Applications',
  },
  MEET_CONDITION_CHECK: {
    TITLE: 'Meet Condition Check',
  },
  FUNCTION_HUB: {
    TITLE: 'Function Hub',
  },
  VIEW_PRIORITY: {
    TITLE: 'Evaluation Priority',
  },
  POLISH_COMMENTS: {
    TITLE: 'Polish Comments',
  },
  REVIEW_APPLICATION: {
    TITLE: 'Shortlisted HKPFS Nominations',
    LIST_NAME: 'Shortlisted HKPFS Nominees',
  },

  PRIORITIZE_EVALUATION: {
    TITLE: 'Prioritise Nominations',
    TIPS: 'Only nominations with the status "Under University Panel" will be listed in the "Prioritise Nominations".',
    HELPER_TEXT:
      'Please press the toggle to activate the Prioritise function. Once activated, you may choose between "Input Mode" or "Drag Mode". In "Input Mode", you can manually enter the order using numbers. In "Drag Mode", you can rearrange applications by dragging them to set their priority. After making your adjustments, click "Save Current Changes" and then press the toggle again to deactivate the Prioritise function. Finally, click "Submit Order to GS" to confirm your adjustments. ',
    SUBMIT_GS_CONFIRM:
      'Please ensure that the applications are in the correct order. Once submitted to GS, no further revisions can be made. Do you confirm your submission?',
    SAVE_CURRENT_CHANGE: 'Save Current Change',
    EDIT: 'Edit',
    PRIORITY_MODE: 'Mode',
    BLOCKER_HELPER_TEXT: {
      CANCEL_PRIORITY_MODE:
        'Are you sure you want to turn off edit mode before saving the current change? The priority records will not be saved.',
      CHANGE_EDIT_MODE:
        'Are you sure you want to change edit mode before saving the current change? The priority records will not be saved.',
      CHANGE_FILTER:
        'Are you sure you want to change funding filter before saving the current change? The priority records will not be saved.',
      LEAVE_PAGE:
        'Are you sure you want to leave the page before saving the current change? The priority records will not be saved.',
    },
    FUNDING_HAS_EXPIRED: '* This funding has expired.',
    SUBMIT_DEADLINE: '* Submission Deadline: ',
    NOTIFICATION: 'Notification',
    S_PANEL: 'S Panel',
    H_PANEL: 'H Panel',
    SUBMIT_ORDER: 'Submit Order to GS',
    SUBMISSION_TIME: `Submission Time: `,
  },
  APPLICATION_OVERVIEW: {
    TITLE: 'Application Overview',
  },
  PANEL_MANAGEMENT: {
    TITLE: 'Panel Management',
    SUBTITLE: 'Panel List',
    ALLOCATE_TEXT: 'Reviewer Allocate:',
    ALLOCATE: 'Allocate',
    RELEASE: 'Release',
    RELEASE_CONFIRM:
      'Do you confirm to release the allocation result? Once released, no further changes can be made.',
    RELEASED_HINT: 'Applications have been released to reviewers.',
    AUTO_REFRESH: 'Auto Refresh',
  },
  TO_DO_LIST: {
    TITLE: 'To-Do List',
  },
  PANEL_MEMBERS: {
    TITLE: 'Panel Members',
  },
  FAILED_LIST: {
    TITLE: 'Failed List',
  },
  DUAL_JOINT_MANAGEMENT: {
    TITLE: 'Dual/Joint Management',
  },
  SCHOLARSHIP_MANAGEMENT: {
    TITLE: 'Scholarship Management',
  },
  PANEL_DETAIL: {
    PANEL_NO: 'Panel No.',
    TITLE: 'Title',
    TYPE: 'Type',
    MEETING_ROUND: 'Meeting Round',
    FUNDING: 'Funding',
    DUE: 'Due',
  },
  MAKE_DECISION: {
    TITLE: 'Make Decision',
  },

  EMAIL_PROCESS: {
    TITLE: 'Email Process',
  },

  OFFER_LIST: {
    TITLE: 'Offered List',
  },

  DRC_ASSESSMENT_DETAILS: {
    DISABLE_EVALUATION_TIP: `Please note that this applicant is exempted from the Scholarship Evaluation process. Kindly proceed to click "submit" once you have completed the assessment.`,
    PARTICULARS: {
      TITLE: 'Applicant Particulars',
      PROGRAMME: 'Programme',
      VALIDE_HKPFS: 'Valid HKPFS Application',
      RECOMMEND_FOR_HKPFS: 'Recommend for HKPFS',
      MORE: 'More About the Application:',
      GO_DETAILS: 'Go  Details',
    },
    ASSESSMENT: {
      TITLE: 'DoRPgS Assessment',
      RETURN_BUTTON_ALERT:
        'Should you decide to return or reject this application, please complete the decision in the Admission Requirement form and submit it directly. No other forms are required.',
      STEP_A: {
        TITLE: 'Academic Qualification',
        CERTIFICATE: 'Certificate(s)',
        TRANSCRIPT: 'Transcript(s)',
        SYSTEM_EXPLANATION: 'Mark Explanation(s)',
        RANKING_PROOF: 'Class Rank Proof(s)',
        OTHER_DOCUMENTS: 'Other Document(s)',
        DEGREE_LEVEL: 'Level of degree',
        INSTITUTION_NAME: 'Name of institution',
        INSTITUTION_COUNTRY: 'Country/Region of Institution',
        OFFICIAL_AWARD_GPA: 'Official Award GPA (Based on 4.0)',
        OUT_OF: ' out of ',
        OFFICIAL_GPA: {
          CONTENT: 'Award/Cum. GPA or Avg Mark (Reference)',
          NOTE_1: 'must be supported by transcript and grading system',
          NOTE_2: `calculated by 
          <a
            className="underline decoration-1 cursor-pointer"
            href="/gpa-helperpage"
            target="_blank"
            rel="noopener"
          >
            GPA/Marker Calculator
          </a>`,
        },
        CLASS_RANKING: {
          CONTENT: 'Rank in class',
          NOTE: 'must be supported by official proof',
        },
        AWARD_CLASSIFICATION: {
          CONTENT: 'Award Classification',
          NOTE: 'must be supported by official proof',
        },
        GPA: {
          TITLE: 'GPA (4-point scale)',
          OUT_OF_4: 'out of 4',
          VIEW_TRANSCRIPT: 'Transcript',
          VIEW_GPA_CONVERSION: 'GPA Conversion',
        },
        HKPFS_NOTE:
          'For HKPFS, either World University Ranking or National Ranking must be completed. Other University rankings will be used for PPPFS & Competitive 3+1 Matching Fund only.',

        RANKING_LINKS: {
          QS: {
            NAME: 'QS world university ranking',
            URL: 'https://www.topuniversities.com/',
          },
          ARWU: {
            NAME: 'ARWU',
            URL: 'http://www.shanghairanking.com/',
          },
          TIMES: {
            NAME: 'Times Higher Education',
            URL: 'https://www.timeshighereducation.com/',
          },
        },
        WOLRD_UNIVERSITY_RANKING_CONTENT: {
          RANKING: 'Ranking',
          UNIVERSITY_RANKING: 'University ranking',
          EXACT_RANKING_NUM: 'Exact ranking number',
          SCORE: 'Score',
          NO_EXACT_RANKING_NUMBER: 'No exact ranking number',
          UL: 'UL',
        },
        WOLRD_UNIVERSITY_RANKING: {
          TOP_1_TO_50: 'Top 1-50',
          TOP_51_TO_100: 'Top 51-100',
          TOP_101_TO_200: 'Top 101-200',
          TOP_201_TO_300: 'Top 201-300',
          TOP_301_TO_400: 'Top 301-400',
          TOP_401_TO_500: 'Top 401-500',
        },
        NATIONAL_RANKING_CONTENT: {
          RANKING: 'Ranking',
          PROOF: 'Proof',
          SCORE: 'Score',
          UL: 'UL',
        },
        WORLD_SUBJECTRANKING_CONTENT: {
          RANKING: 'Ranking',
          SUBJECT_RANKING: 'Subject ranking',
          SUBJECT_AREA: 'Subject Area',
          SCORE: 'Score',
          UL: 'UL',
        },
        WOLRD_SUBJECT_RANKING: {
          TOP_1_TO_20: 'Top 1-20',
          TOP_21_TO_50: 'Top 21-50',
          TOP_51_TO_75: 'Top 51-75',
          TOP_76_TO_100: 'Top 76-100',
          TOP_101_TO_150: 'Top 101-150',
        },
        NATIONAL_RANKING: {
          FIRST_TIER: 'First-tier National Universities',
          SECOND_TIER: 'Second-tier National Universities',
        },
        DISCIPLINE_SPECIFIC_LIST_CONTENT: {
          NOTE: 'The approved Discipline-specific University List can be used by all departments/schools for the specific discipline/area but not on a departmental basis.',
          REFER:
            'Please refer to the discipline-specific list and indicate the UL level.',
          DISCIPLINE_AREA: 'Discipline/Area',
          RANKING: 'Ranking',
          SCORE: 'Score',
          UL: 'UL',
        },
      },
      STEP_B: {
        TITLE: 'Publication',
        SUBTITLE: 'Publication',
        SPECIAL_LIST: {
          F: 'The approved ',
          L: ' can be used by the respective departments/schools.',
          LABEL: 'Discipline-specific Publication List',
          URL: 'https://www.polyu.edu.hk/gs/docdrive/staff/UPSF/Approved_Discipline_specific_Publication_List.pdf',
        },
        NOTE: {
          LABEL: 'USPF',
          URL: 'https://www.polyu.edu.hk/gs/docdrive/staff/UPSF/UPSF.pdf',
          TITLE:
            'Note: The total no. below, which is specifical for HKPFS applications, count all types of research publications/outputs. As the HKPFS applications will be considered for PPPFS/Competitive 3+1 Matching Fund, DoRPgS should still assess each publication according to ',
        },
        TITLE_OF_PUBLICATION: 'Title of Publication',
        NAME_OF_JOURNAL: 'Name of Journal/Conference/Publisher',
        AUTHORS: 'List all Authors',
        PUBLICATION_TYPES: 'Publication Type',
        PUBLICATION_DATE: 'Publication Date',
        PUBLICATION_STATUS: 'Publication Status',
        APPLICANT_ROLE: 'Role of applicant',
        CITATION: 'Citation Information',
        SPECIFY_ROLE: 'Specify the role',
        URL: 'URL of the Publication',
        SUPPORTTING: 'Supporting Document(s)',
        PUBLICATION_TYPE: {
          TITLE: 'Type',
          JCR_Q1: 'JCR Q1 paper',
          JCR_Q1_EQUIVALENT:
            'Discipline-specific List(GSB approve, equivalent to JCR Q1)',
          JCR_Q2: 'JCR Q2 paper',
          JCR_Q2_EQUIVALENT:
            'Discipline-specific List(GSB approve, equivalent to JCR Q2)',
          NA: 'This entry should not be considered as it is not qualified / no proof is provided.',
          NA_OPTION: 'None of the above',
        },
        RL: 'RL Point',
      },
      ENTER_CONTACT_INFO:
        'Please enter your contact information and "Meet Condition Deadline" below. ',
      STEP_C: {
        TITLE: 'Merit',
        SUBTITLE: 'Merit',
        SPECIAL_LIST: {
          F: 'The approved ',
          L: ' will be 3 scores each, the list can be used by all Departments/ Schools. All other merits at or above university level will be 1 score each.',
          LABEL: 'Prestigious Merit List',
          URL: 'https://www.polyu.edu.hk/gs/docdrive/staff/UPSF/Approved_Prestigious_Merit_List.pdf',
        },
        NOTE: `Merits/Scholarships should be related to academic/research performance and able to reflect applicants' capability. Honourable Mention / Participation Award should not be considered. Official proof issued by the awarding body is required.`,
        MERIT_NAME: 'Name of Merit',
        SPECIFY:
          'Specify the name of the award, position and year won by the applicant',

        AWARDING_BODY: 'Name of Awarding Body',
        AWARD_PROOF: 'Proof of Award',
        AWARD_YEAR: 'Year of the Award',
        SUPPORTTING: 'Supporting Document(s)',
        AWARD_POSITION: 'Award Country/Region',
        MERIT_TYPE: {
          TITLE: 'Type',
          PRESTIGIOUS: 'Prestigious Merit List',
          OTHER: 'Other Merit at or above the university level',
          NA: 'This entry should not be considered as it is not qualified / no proof is provided.',
        },
        RL: 'RL Point',
        SCORE: 'Score',
      },
      STEP_D: {
        TITLE: 'Department Input',
        HIGH_QUALITY: 'High-quality research proposal (Form GSB/1a)',
        TWO_STRONG_REFEREE: `Received referee's reports/reference letters in English`,
        SUPERVISOR_RECORD: `Chief Supervisor's track record`,
        DEPT_IMPACT: 'Departmental Impact',
        ASSESSMENT_BY_DSRC: 'Assessment by DoRPgS',
        FULL_SET_APPLICATION:
          'Full set of the application with supporting documents',
        DSRC_CONFIRM:
          'The DoRPgS confirms the file has included the SRS application and all other required proof and supporting documents.',
        ASSESSMENT_OPTIONS: {
          VERY_STRONG: 'Very Strong',
          STRONG: 'Strong',
          MODERATE: 'Moderate',
          WEAK: 'Weak',
          VERY_WEAK: 'Very Weak',
          NA: 'NA',
        },
      },
      STEP_E: {
        TITLE: 'Bonus',
        NOTER: 'Note',
        NO_DOUBLE: 'No double count is allowed.',
        JUSTIFICATION: 'Justification',
        SUPPORTING_DOC: 'Supporting Document',
        ACCURACY:
          'The DoRPgS has verified the accuracy of the above information.',
        NOT_QUALIFIED:
          'This entry should not be considered as it is not qualified / no proof is provided.',
        ALERT:
          'You have not completed the assessment, please complete all radio boxes.',
        NO_BONUS_NOTIFICATION:
          'This application has no Bonus record. No Assessment is required.',
      },
      STEP_G: {
        TITLE: 'Admission Requirement',
        ADMISSION: {
          TITLE: '1. Admission',
          SUPERVISOR_DECISION: `Programme Proposed by Supervisor`,
          NOMINATED_ADMISSION: {
            TWO_YEAR_FULL_TIME_MPHIL: '2-year Full-time MPhil',
            FOUR_YEAR_PART_TIME_MPHIL: '4-year Part-time MPhil',
            THREE_YEAR_FULL_TIME_PHD: '3-year Full-time PhD',
            SIX_YEAR_PART_TIME_PHD: '6-year Part-time PhD',
            FOUR_YEAR_FULL_TIME_PHD: '4-year Full-time PhD',
            EIGHT_YEAR_PART_TIME_PHD: '8-year Part-time PhD',
          },
          RETURN: 'This application will be returned to the',
          A1: 'a. We ',
          A2: ' this applicant for admission to the programme.',
          C: 'c.  Firm/Conditional offer:',
          B: {
            TITLE:
              'b. For admission of the applicant not meeting general entrance requirements or English language requirements',
            OPTION_1:
              "We endorse the justifications of recommendation for admission. <em>(FRC/SB's approval is required)</em>",
            OPTION_2:
              'We do not endorse the justifications of recommendation for admission.',
          },
          SPECIFY_CONDITIONS:
            'Please specify the condition(s) that the applicant must meet to be admitted to the programme',
          CUSTOM_CONDITION_DETAIL: 'Custom condition details',
          GENERAL_REQUIREMENT: 'General Entrance Requirement',
          ENGLISH_REQUIREMENT: 'English Language Requirement',
          OTHER_TEST_REQUIREMENT: 'Other Test Requirement',
          ADDITIONAL_REQUIREMENT: 'Additional Requirement',
        },
        STIPEND: {
          TITLE:
            '3. Stipend (applicable to applicants admitted to full-time programme only)',
          OPTION_1:
            'I approve that the duration of the fellowship/scholarship to be provided to this applicant. Extension of this fellowship/scholarship will be reviewed subject to satisfactory performance and availability funds. ',
          OPTION_2:
            'I do not agree to the award of the fellowship/scholarship to the applicant. ',
        },
        PLAGIARISM: {
          TITLE: '4. Plagiarism Checking',
          QUESTION_1:
            'This is to confirm plagiarism checking has been conducted to Research Plan and Vision Statement (in Section G of Student Application) of this nomination.',
          QUESTION_2:
            'This is to confirm that suspected plagiarism is NOT detected in Research Plan and Vision Statement (in Section G of Student Application) of this nomination.',
        },
        TUITION_FEE: {
          TITLE: '2. Tuition Fee Assistantship provided by Department/School',
          PROVIDE_1: 'We',
          PROVIDE_2:
            'tuition fee assistantship to this applicant for admission.',

          CHIEFSUPERVISOR_ACCOUNT: 'Account code provided by Chief Supervisor:',
          SCHOOL_ACCOUNT: 'Account code provided by the Department/School:',
        },
        ACCOUNT_CODE: 'Account Code',
        SUPERVISOR_TEAM_CHECK_1:
          'The D/SRC Chair is a member of the supervisory team.',
        SUPERVISOR_TEAM_CHECK_2:
          'The DoRPgS is a member of the supervisory team.',
      },
      STEP_F: {
        TITLE: 'Scores on applicant',
        FIRST_DEGREE_UNIVERSITY_RANKING: 'First Degree University Ranking',
        FIRST_DEGREE_GPA_RANKING: 'First Degree GPA / Class Ranking',
        PUBLICATION_MERIT: 'Publication / Merit',
        DEPARTMENT_INPUT: 'Department Input',
        BONUS: 'Bonus',
        TOTAL: 'Total',
      },
      STEP_H: {
        TITLE: 'Declaration',
        BY_SUBMITTING: 'By submitting this form, the DoRPgS confirm that:',
        PI_OF_STEM: 'I am the PI of STEM/SHS Project',
        PI_OF_GRF: 'I am the PI of GRE Project',
        ALL_INFORMATION_CONSIDERED:
          'All information submitted is true and accurate with proof and I understand that nominations with missing, incomplete and / or inaccurate information will not be considered.*',
        IS_SUPPORTED:
          'The admission of the applicant as a PhD student is supported if the application is successful.*',
        PAY_THE_STIPEND:
          'The Department/School will pay the stipend in the event that the Chief Supervisor cannot provide funding as required.*',
        IS_PROOF: 'The submitted information has been verified with proof.*',
        HKPFS_RECOMMENDATION: {
          MEET_F: 'The applicant has met the ',
          LINK: {
            LABEL: 'Recommendation Threshold',
            URL: 'https://www.polyu.edu.hk/gs/polyu_all_staff/hkpfs/',
          },
          MEET_L:
            ' for HKPFS and understand that applicants failing to meet the threshold will risk disqualification.*',
        },
        MAKE_UP_STIPEND_BUDGET: `The stipend budget has been reserved by RIO/FO for the account(s) provided by the Chief Supervisor.`,
        REMARKS: 'Remarks to GS (if any)',
        RETURN_REMARKS: {
          GS: 'Remarks from GS ',
          FRC: 'Remarks from FRC/SB',
          HOD: 'Remarks from HoD/DoS',
          DRC: 'Remarks from D/SRC',
          SUP: 'Remarks to Supervisor from DoRPgS',
          APP: 'Remarks to Applicant from DoRPgS',
        },
      },
    },

    REFEREE_CONFIRM: {
      TITLE: 'Referee Report Confirmation',
      CHECKBOX_LABEL: 'I hereby confirm the validity of this referee report.',
      ACADEMIC_REFEREE: 'Academic Referee',
      SAVE: 'Save',
      NA: 'N/A',
      SUCCESS: 'Saved Academic Referee Confirmation Successfully.',
      FAIL: 'Saved Academic Referee Confirmation Failed.',
      HKPFS_CONFIRM: 'Saved the Referee Report Selection Successfully.',
    },

    PANEL_INFORMATION: {
      TITLE: 'Panel Information',
      CONFIRM: 'I confirm the shortlisting of this candidate for interviews.',
      PANEL_CHAIR: 'Panel Chair',
      PANEL_MEMBER: 'Panel Member(s)',
      MEMBER: 'Member',
      MEMBER_INFO: {
        RANK: 'Rank',
        POST: 'Post',
        NET_ID: 'Net ID',
        GIVEN_NAME: 'Given Name',
        SURNAME: 'Surname',
        NAME: 'Name',
        DEPARTMENT: 'Department',
        EMAIL: 'Email',
        INSTITUTION: 'Institution',
      },
    },
    CONDITION_CHECK: {
      TITLE: 'Condition Check',
      CONTACT_PERSON: {
        TITLE: 'Applicant Status',
        NAME: 'Contact Person Name',
        PHONE: 'Contact Person Phone No.',
        EMAIL: 'Contact Person Email',
        CONDITION_DEADLINE: 'Meet Condition Deadline',
      },
      CONDITION_OFFER_TYPE: 'Condition Offer Type',
      GENERAL_ENTRANCE_REQUIREMENTS: 'General Entrance Requirements',
      ENGLISH_LANGUAGE_REQUIREMENTS: 'English Language Requirements',
      CONDITION_DEADLINE: 'Meet Condition Deadline',
      PROOF_FILES: 'Proof Files',
      CONDITION_CHECK: 'Condition Check',
      REMARKS: 'Remarks to Applicant (if any)',
      MEET: 'Meet',
      NOT_MEET: 'Not Meet',
    },
    EMPTY_TEXT: {
      ACADEMIC_QUALIFICATION:
        'No Academic Qualification Record here. No Assessment is required.',
      PUBLICATION: 'No Publication Record here. No Assessment is required.',
      MERIT: 'No Merit Record here. No Assessment is required.',
    },
    SUBMIT_SUCCESS: 'DoRPgS Assessment Submitted Successfully',
    STIPEND_UNFILLED_WARNING: 'Please fill in the 3.',
    VALIDATION_SUBMIT: {
      FILL_GSB: 'Please complete and save the Admission Requirement',
      FILL_REFEREE_CONFIRM: 'Please complete and save the Report Confirmation',
      FILL_ACADEMIC_QUALIFICATION:
        'Please complete and save the Academic Qualification Assessment',
      FILL_PUBLICATION: 'Please complete and save the Publication Assessment',
      FILL_MERIT: 'Please complete and save the Merit Assessment',
      FILL_DEPARTMENT_INPUT:
        'Please complete and save the Department Input Assessment',
      FILL_BONUS: 'Please complete and save the Bonus Assessment',
      FILL_DECLARATION: 'Please complete and save the Declaration',
      FILL_PANEL_MEMBER: 'Please complete and save the Panel Interview',
      SUBMIT_SUCCESS: 'Your assessment submitted successfully',
    },
    SUBMIT_CONFIRM: {
      TITLE_RETURN: 'Are you sure you want to return this assessment?',
      TITLE_APPROVE: 'Are you sure you want to submit this assessment?',
      TITLE_REJECT: 'Are you sure you want to reject this assessment?',
      CONTENT:
        'By submitting, your assessment will be processed to D/SRC, HoD/DoS, FRC/SB or GS. This action cannot be reversed.',
      CONTENT_REJ:
        'By submitting, this application will be rejected. This action cannot be reversed.',
      CONTENT_RET:
        'By submitting, this application will be returned to the target unit for revision and resubmission. This action cannot be reversed.',
    },
  },
  DSRC_APPROVAL_DETAILS: {
    ASSESSMENT: {
      TITLE: 'D/SRC Approval',
      DRC_CHAIR: {
        TITLE:
          '(For approval on the DoRPgS as a member of the supervisor team)',
        OPTION_0: 'We ',
        OPTION_1: ' his/her recommendation for admission of the applicant.',
      },
      REMARKS_LABEL: 'Remarks to DoRPgS for disapproval',
      NOT_REQUIRED_1: `It appears that the previously returned assessment has been revised. After this adjustment, the assessment no longer requires D/SRC's approval.`,
      NOT_REQUIRED_2: 'Please click `Submit` to proceed.',
    },
    SUBMIT_CONFIRM: {
      TITLE: 'Are you sure you want to submit this assessment?',
      CONTENT:
        'By submitting, your assessment will be processed. This action cannot be reversed.',
      CONTENT_RET:
        'By submitting, this application will be returned to the target DoRPgS for revision and resubmission. This action cannot be reversed.',
    },
    SUBMIT_SUCCESS: 'D/SRC Assessment Submitted Successfully',
    PREVIEW_DIALOG: {
      TITLE: 'Preview',
      CONTENT:
        'Please note that this is a returned D/SRC assessment. Kindly review the associated remarks, make the necessary assessment, and resubmit it.',
    },
  },

  FRC_ASSESSMENT_DETAILS: {
    ASSESSMENT: {
      TITLE: 'FRC/SB Approval',
      DRC_CHAIR: {
        TITLE:
          'For approval on the DoRPgS and D/SRC Chair as a member of the supervisor team',
        OPTION_0: 'We ',
        OPTION_1: ' his/her recommendation for admission of the applicant.',
      },
      REQUIREMENTS: {
        TITLE:
          'For approval on the admission of the applicant not meeting general entrance requirements or English language requirements',
        OPTION_0: 'We ',
        OPTION_1: ' the recommendation for admission.',
      },
      REMARKS_LABEL: 'Remarks to DoRPgS for disapproval',
      NOT_REQUIRED_1: `It appears that the previously returned assessment has been revised. After this adjustment, the assessment no longer requires FRC/SB's approval.`,
      NOT_REQUIRED_2: 'Please click `Submit` to proceed.',
    },
    SUBMIT_CONFIRM: {
      TITLE: 'Are you sure you want to submit this assessment?',
      CONTENT:
        'By submitting, your assessment will be processed. This action cannot be reversed.',
      CONTENT_RET:
        'By submitting, this application will be returned to the target DoRPgS for revision and resubmission. This action cannot be reversed.',
    },
    SUBMIT_SUCCESS: 'FRC/SB Assessment Submitted Successfully',
    PREVIEW_DIALOG: {
      TITLE: 'Preview',
      CONTENT:
        'Please note that this is a returned FRC/SB assessment. Kindly review the associated remarks, make the necessary assessment, and resubmit it.',
    },
  },
  GS_ASSESSMENT_DETAILS: {
    PARTICULARS: {
      TITLE: 'Applicant Particulars',
    },
    CHECK_STEPPER: {
      OFFER_CHECK: {
        TITLE: 'Offer Check',
        DESCRIPTION: '',
      },
      OFFER_DECISION: {
        TITLE: 'Offer Decision',
        DESCRIPTION: '',
      },
    },
    CHECK: {
      SECTION_A: {
        TITLE: 'Section A',
        APPLICATION_NO: 'Application No',
        APPLICATION_NAME: 'Applicant Name',
        VISA_TYPE: 'Visa Type',
        LOCAL_INDICATOR: 'Local indicator',
        DECLARATION: 'Finished Application Declarations',
        LOCAL_REF1:
          'If the applicant is holding one of the documents listed in JUPAS ',
        LOCAL_REF_LINK:
          '(https://www.jupas.edu.hk/en/page/detail/3670/#def_nls)',
        LOCAL_REF2: ' > eligible to receive tuition fee waiver',
        OFFER_DEPT: 'Offering Department',
        OFFER_TYPE: 'Offer Type',
        PROGRAMME_OFFERED: 'Programme Offered to Applicant',
        PROGRAMME_REF:
          'Refer to Research Postgraduate - Admission Requirements',
        PROGRAMME_LINK:
          '(http://www51.polyu.edu.hk/eprospectus/rpg/admission-requirements)',
        PROGRAMME_REF_A:
          'a) (for 3-year PhD) an MPhil or equivalent (a research postgraduate degree with a dissertation as an award requirement) conferred by a recognised university à check transcript and certificate with a thesis/dissertation',
        PROGRAMME_REF_B:
          'b) (for 4-year PhD) holds Master’s degree or Bachelor’s degree with First Class Honours',
        PROGRAMME_REF_C:
          'c) (for MPhil) holds a Bachelor’s degree with Second Class Honours or above',
        SEMESTER: 'Commencement semester',
        CHIEF_SUP: 'Chief Supervisor',
        CO_SUP: 'Co-supervisor(s)',
        PREVIOUS_SUCCESSFUL:
          'Chief Supervisor has previous successful supervision experience',
        PREVIOUS_SUCCESSFUL_RMK:
          'If “No”, there is a Co-supervisor appointed. Please check the',
        PREVIOUS_SUCCESSFUL_LINK: 'Supervisor Team in Supervisor Nomination',

        EDUCATION: '11. Academic Qualification',
        LANGUAGE: '12. Language Qualification',
        OTHER_TEST: '13. Other Test Qualification',
        REFEREE_REPORTS: `14. Referee's Reports`,
        FUNDING: 'Source of Funding to Support the First Year of Study',
        ACCOUNT_CODE: 'Account Code',
        FUNDING_ARRANGEMENT: 'Funding Arrangement',
        CHIEF_SUP_REMARKS: `Remarks from Chief Supervisor`,
        PROOF_DOC:
          'Proof of Incentive Scheme & Strategic Allocation Categories',
        SCHEME_ENTRANCE_REQ: 'Scheme entrance requirement a) OR b)',
        SCHEME_ENTRANCE_REQ_A1:
          'a) First Degree University / Subject Ranking: ',
        SCHEME_ENTRANCE_REQ_A2: ' First Degree GPA / Class Ranking: ',
        SCHEME_ENTRANCE_REQ_B: 'b) Publication / Merit Score: ',
        FROM: 'from: ',
        TO: 'to: ',
        CERTIFICATE: 'Certificate',
        TRANSCRIPT: 'Transcript',
        CONDITIONS: 'Conditions',
        DEADLINE: 'Deadline',
        CONTACT_PERSON: 'Contact Person',
        PUBLICATION: 'Publications:',
        MERIT: 'Merits:',
      },
      SECTION_B: {
        TITLE: 'Section B',
        DECLARATION: '1. Supervisor(s) Declaration',
        JUSTIFICATION_FOUR_YEAR:
          '2. justifications for admission to a 4-year full-time/8-year part-time PhD',
        CONDITION_JUSTIFICATION:
          '3. Justification for admission of the applicant not meeting general entrance requirement/ English language requirement (if any)',
        TUITION_FEE:
          '4. Tuition Fee Assistantship provided by Department/School',
        STIPEND: '5. Stipend',
        STIPEND_REMARK: ' (Remark: pay attention to full-time with no stipend)',
        DORPGS_REMARKS: '6. DoRPgS Remarks to GS (if any)',
        DSRC_APPROVAL: '7. D/SRC’s Approval',
        HOD_DOS_APPROVAL: '8. HoD/DoS’s Approval',

        FRC_APPROVAL: '9. FRC/SB’s Approval',
        FRC_APPROVAL_REMARKS: {
          FRC_APPROVAL_REMARK_A: 'Only applicable ',
          FRC_APPROVAL_REMARK_B:
            '(i) for admission of the applicant not meeting general entrance requirement/ English language requirement ',
          FRC_APPROVAL_REMARK_C:
            '(ii) DoRPgS and D/SRC Chair are in the supervisory team.',
        },
        CHIEF_SUP: 'Chief Supervisor:',
        CO_SUP: 'Co-supervisor:',
        SUP: 'Supervisor:',
        DORPGS: 'DoRPgS:',
        DRC: 'D/SRC:',
        HOD: 'HoD/DoS (based on the last HoD/DoS assessment record):',
        FRC: 'FRC/SB:',
      },
      SECTION_C: {
        TITLE: 'Section C',
        NOTE: 'These remarks are provided in chronological order when the application is returned for further action.',
      },
      NOTE: 'You have finished the Offer Check, please move to next step to make the Offer Decision.',
      SAVE: 'Confirm',
      SUCCESS_NOTE:
        'Checked All Information Successfully. Please move to next step to make the Offer Decision.',
    },
    ASSESSMENT: {
      TITLE: 'GS Decision',
      GS_DECISION: 'Decision',
      REMARKS: {
        DRC: 'Remarks to GS from DoRPgS',
        PANEL: 'Remarks to GS  from Panel',
        RETURN_REMARKS: 'Remarks',
        REMARKS_TO_AU: 'to Corresponding Academic Unit (required)',
      },
      RESULT: 'Panel Result:',
      DECISION: {
        RETURN: 'Return the Application',
        REJECT: 'Reject the Application',
        OFFER: 'Make offer to the Applicant',
        TRANSPER: 'Transfer to another Panel',
        GO_TO_PANEL: 'Go to panel selection',
      },
      CHECKING_INFO: {
        FIRST_CHECK_BY: 'First Checked By: ',
        FINAL_CHECK_BY: 'Final Checked By: ',
      },
      NEXT_ASSIGNEE: 'Assign To The Second Colleague',
      GEN_OFFER_NOTE:
        'Before Submission, GS Members should generate the files and check or modify them all.',
      DOUBLE_CHECK: '(Requires Double Check)',
      CLICK_TO_GEN: 'Generate',
      CLICK_TO_REGEN: 'Regenerate',
      REMOVE: 'Remove',
      PREVIEW_DATA: {
        PROGRAMME_CODE_SUBCODE: 'Programme Code',
        COMMENCEMENT: 'Study Commencement Date',
        HAS_FELLOWSHIP: 'has Fellowship',
        FELLOWSHIP: 'Fellowship Scheme',
        FT_LOCAL: 'Full-time & Local',
        SELF_FINANCED: 'is Self Financed',
        HAS_ASSISTANTSHIP: 'has Assistantship',
        ASSISTANTSHIP: 'Assistantship',
        RESIDENCE_REQ: 'Residence Requirements',
      },
      OFFER_CHECK: 'Offer Check',
      FILE_TYPE: {
        TRANSCRIPT: 'Transcript',
        NOO: 'Notice Of Letter',
        FUNDING_LETTER: 'Funding Letter',
        OEP: 'Offer Email Preview',
      },
      FILE: 'File: ',
      NO_CHECK_SUBMIT_CONFIRM: {
        TITLE: 'Are you sure you want to submit your decision?',
        CONTENT:
          'Please ensure that all information has been reviewed accurately. This action cannot be reversed.',
      },
      FIRST_CHECK_SUBMIT_CONFIRM: {
        TITLE:
          'Are you sure you want to submit your decision for the first check?',
        CONTENT:
          'Please ensure that all information has been reviewed accurately. This decision will be subject to a final review by another person. This action cannot be reversed.',
      },
      SECOND_CHECK_SUBMIT_CONFIRM: {
        TITLE: 'Are you sure you want to submit your final decision?',
        CONTENT: `Please ensure that you have reviewed the first person's decision and that all information is correct. This action will finalize the GS decision process and cannot be reversed.`,
      },
      SUBMIT_SUCCESS: {
        CONTENT: `GS Assessment Submitted Successfully.`,
      },
      PREVIEW_DIALOG: {
        TITLE: 'Preview',
        CONTENT:
          'Please note that this is a returned GS assessment. Kindly review the associated remarks, make the necessary assessment, and resubmit it.',
      },
    },
  },

  HOD_DOS_ASSESSMENT: {
    ASSESSMENT: {
      TITLE: 'HoD/DoS Approval',
      REJECT: 'Reject',
      APPROVE: 'Approve',
      RETURN_TO_DSRC: 'Return to DoRPgS',
      REMARK_TO_DSRC: 'Remarks to DoRPgS',
      REMARKS: 'Remarks',
      NOT_REQUIRED_1: `It appears that the previously returned assessment has been revised. After this adjustment, the assessment no longer requires HoD/DoS's approval.`,
      NOT_REQUIRED_2: 'Please click `Submit` to proceed.',
      FOR_EXTERNAL: {
        TITLE:
          'For admission using external grants/funds, internal grants/funds or DEA, I decide to',
        ACCOUNT_CODE: 'Account Code:',
        CONTENT:
          'I confirm that the Department/School will pay the 12-month stipends in the event that the planned funding support is eventually not available.',
      },
      FOR_UNDER_STRATEGIC: {
        TITLE:
          'For admission under strategic allocation for Non-STEM / Non-SHS / New Recruits, I decide to',
        CONTENT_1:
          'I confirm that the Chief Supervisor is eligible for receiving the PhD quota.',
        CONTENT_2: 'The assumption date of the Chief Supervisor is',
      },
      FOR_DUAL: {
        TITLE: 'For admission under Dual PhD Degree Programmes, I decide to',
        CONTENT:
          'I confirm that the Department/School will pay the required stipends matching for the Dual PhD Degree Programme, in the event that the planned funding support is eventually not available.',
      },
      FOR_COMPETITIVE: {
        TITLE: 'For admission using PolyU Competitive PhD Funding, I decide to',
        CONTENT:
          'I confirm that the Department/School will pay the required stipends matching for the PolyU Competitive PhD Funding, in the event that the planned funding support is eventually not available.',
      },
    },
    SUBMIT_CONFIRM: {
      TITLE: 'Are you sure you want to submit this assessment?',
      CONTENT:
        'By submitting, your assessment will be processed. This action cannot be reversed.',
    },
    PREVIEW_DIALOG: {
      TITLE: 'Preview',
      CONTENT:
        'Please note that this is a returned HoD/DoS assessment. Kindly review the associated remarks, make the necessary assessment, and resubmit it.',
    },
    SUBMIT_SUCCESS: 'HoD/DoS Assessment Submitted Successfully',
  },
  APPLY: 'Apply',
  CLEAR: 'Clear',
  TRUE: 'True',
  FALSE: 'False',
  ADD: 'Add',
  REMOVE: 'Remove',
  SAVE: 'Save',
  SUBMIT: 'Submit',
  RETURN_REJECT: 'Return / Reject',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  BACK: 'Back',
  YES: 'Yes',
  NO: 'No',
};

export const MONITOR_LIST_TEXT = {
  PANEL_TYPE: 'Disciplines',
  FUNDING_SCORE: 'Total Score(Dept. Override)',
  PAGE_TITLE: 'Applications',
  ASSIGNED: 'Assigned',
  APPLICATION_NO: 'Application No.',
  ORDER: 'Order',
  APPLICANT_NAME: 'Applicant Name',
  STUDENT_NUMBER: 'Student Number',
  PROG_LEVEL: 'Prog.Level',
  RESEARCH_FIELD: 'Research Field',
  CS_SUBMISSION_TIME: 'Submission Time (CS to DoRPgS)',
  STUDY_MODE: 'Study Mode',
  DEPARTMENT: 'Department',
  CHIEF_SUPERVISOR: 'Chief Supervisor',
  FUNDING_SCHEME: 'Funding Scheme',
  PROG_TYPE: 'Prog.Type',
  COMMENCEMENT_DATE: 'Commencement Date',
  ENTRY_YEAR: 'Entry Year',
  HKPFS_REFERENCE_NUMBER: 'HKPFS Ref No',
  VALID_HKPFS_APPLICATION: 'Valid HKPFS Application',
  STATUS: 'Status',
  CONDITION_DDL: 'Condition DDL',
  MEET_CONDITION: 'Meet Condition',
  CHECK_STATUS: 'Check Status',
  PROG_CODE: 'Prog.Code',
  ACTION: 'Action',
  GSASSIGNEE: 'GS Assignee',
  OFFER: 'Offer',
  OFFER_DATE: 'Offer Date',
  ALL: 'All',
  UNASSIGNED: 'Unassigned',
  PROGRAMME_LEVEL: {
    DOCTOR_OF_PHILOSOPHY: 'PhD',
    MASTER_OF_PHILOSOPHY: 'MPhil',
  },
  STUDY_MODE_TYPE: {
    FULL_TIME: 'FT',
    PART_TIME: 'PT',
  },
  PROGRAMME_TYPE: {
    TITLE: 'Programme Type',
    GENERAL_PROGRAMME: 'General Programme',
    SPONSORED_PHD_PROGRAMME: 'Sponsored PhD Programme',
    DUAL_PHD_DEGREE_PROGRAMME: 'Dual PhD Degree Programme',
    COLLABORATIVE_PHD_DEGREE_PROGRAMME: 'Collaborative PhD Degree Programme',
  },
  CONDITION_STATUS: {
    CREATED: 'Created',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    MODIFICATION_REQUIRED: 'Modification Required',
  },
  HKPFS: 'Recommend For HKPFS',
  EXPORT_CSV: 'Export RSF file',
  CONFIRM_RSF: 'Confirm RSF uploaded',
  RELEASE_DATE: 'Expected Release Date',
  SUBMIT_TO_GS_DATE: 'Submit to GS Date',
  NOT_YET_RELEASED: 'Not Yet Released',
  EXPORT_ALL_DATA: 'Export All Application Data',
  EXPORT_HKPFS_DATA: 'Export HKPFS Data',
};

export const ASSESSMENT_HOME_PAGE_TEXT = {
  ASSESSMENT: 'Assessment',
  APPLICATION_LIST: 'Application List',
  NON_PROPOSED: 'Non-proposed Applications',
  APPLICATIONS: 'Applications',
  APPLICATION_TO_CHECK: 'Applications to Check',
  APPLICATION_OVERVIEW: 'Application Overview',
  VIEW_LIST: 'View List',
  PANEL_MANAGEMENT: 'Panel Management',
  MEET_CONDITION_CHECK: 'Meet Condition Check',
  TO_DO_LIST: 'To-Do List',
  ROUNDS: 'Rounds',
  OFFERS: 'Offers',
  FAILED_LIST: 'Failed List',
  DECISIONS: 'Decisions',
  EMAILS: 'Emails',
};

export const COMMON_FILTER_TEXT = {
  TITLE: 'Table Filter',
  FILTER_CATEGORY: {
    DEPT: 'Department', // update at 27/03/2025, currently no faculty filter
    COUNTRY: 'Country',
    ENTRY_YR: 'Entry Year',
    CURRENT_STATUS: 'Current Status',
    EMAIL: 'Email',
    ADM_PROG: 'Academic Programme',
    LOCAL_INDICATOR: 'Local Indicator',
    HKPFS_INDICATOR: 'HKPFS Indicator',
    GS_ASSIGNEE: 'GS Assignee',
    APPLICATION_NO: 'Application No.',
    APPLICATION_NAME: 'Applicant Name',
    VISA_STATUS: 'Visa Status',
    QUALIFICATION_CHECK_STATUS: 'Qualification Check Status',
    MEET_CONDITION_STATUS: 'Meet Condition Status',
    SCHOLARSHIP_IND: 'Scholarship Indicator',
    TAGS: 'Tag(s)',
    PARTNER_UNI: 'Partner University',
    RESULTS: 'Result(s)',
    PRIORITY_ORDER: 'Priority Order',
    SERIAL_NO: 'Serial No.',
    ADVANCED_SEARCH: 'Advanced Search',
    ADVANCED_SEARCH_TOOLTIP:
      'When the above filter boxes do not meet you needs, you can use conditional expression here for advanced search. For example, entering <i>ae+rp>=9</i> means filtering out all applications where the sum of Academic Excellence and Research Ability and Potential is not less than 9 points. Below are the currently supported conditional dimensions and their explanations.',
  },
  APPLY: 'Apply',
  CLEAR: 'Clear',
};

export const PANEL_LIST_TEXT = {
  PANEL_NO: 'Panel No.',
  TITLE: 'Title',
  ROUND: 'Round',
  ENTRY_YEAR: 'Entry Year',
  TYPE: 'Disciplines',
  FUNDING: 'Funding',
  MEETING_DATE: 'Panel Meeting Date',
  APPLICATIONS_NUMBER: 'No. of Recommended Applications: ',
  PANEL_RESULT_SUCCESSFULL: 'Selection Result (Successful): ',
  PANEL_RESULT: 'Selection Result: ',
  STATUS: 'Status',
  FORM_PANEL: 'Add Panel',
  CREATE_PANEL_SUCCESS: 'Panel Created Successfully',
  SAVE_PANEL_SUCCESS: 'Panel Saved Successfully',
  DELETE_PANEL_SUCCESS: 'Panel Deleted Successfully',
  ACTION: 'Action',
  SUBMIT: 'Submit Final Result',
  SUBMITTED: 'The panel result has been successfully announced.',
  PANEL_DELETE: {
    TITLE: 'Notification:',
    CONTENT: 'Are you sure you want to delete this panel?',
  },
  STUDENTSHIP_YEARS_GIVEN_BY_PANEL: 'Studentship Years Given by Panel:',
};

export const PANEL_DETAIL_APPLICATION_TEXT = {
  SERIAL_NUMBER: 'Serial No.',
  APPLICATION_NO: 'Application No.',
  DUAL_APPLICATION_NO: 'Application No. | Partner University',
  NAME: 'Name',
  NATIONALITY: 'Nationality',
  RESULT: 'Result',
  AVG_REVIEW_SCORE: 'Total Avg. Score',
  OFFERED_PROGRAMME: 'To be Offered Programme',
  REMAINING_STUDENTSHIP_YEAR: 'Remaining Studentship Year',
  EXCEED_HINT:
    'Remaining Studentship Year exceeds the offered program duration',
  FIRST_DEGREE:
    'First Degree University & GPA | Class Ranking | School Ranking',
  SECOND_DEGREE:
    'Second Degree University & GPA | Class Ranking | School Ranking',
  TOTAL_SCORE: 'Dept. Score',
  DEPARTMENT: 'Dept.',
  CS_STUDENTSHIP_YEARS: 'Studentship Year from CS',
  DEPT_PRIORITY_NO: 'System Score | Dept.Score | Dept. Priority',
  ACTION: 'Action',
  PANEL_SELECTION: 'Panel Selection',
  TAGS: 'Tags',
  DISCIPLINE: 'Discipline',
  REVIEWER: 'Confirm Reviewed | Reviewers | Dept.Score',
  TOP_TEN: 'Top 10%',
  RATING: 'Rating',
  RATING_EXPLANATION: 'AI Score / Dept Override Score (if applicable)',
  DETAIL: 'Details',
  PUBLICATION: 'Publication',
  PUB_ACCEPTED: '*Accepted / Published only',
  PUB_EXPLANATION: '1st Author / 2nd Author / Corresponding Author only',
  MERIT: 'Merit',
  REMARK_PANEL: 'Remarks to Panel',
  REMARK_DORPGS: 'Remarks to DoRPgS',
  VIEW_PROFILE: 'View Applicant Profile',
  Q1_COUNT: 'Q1 Paper',
  Q2_COUNT: 'Q2 Paper',
  CURRENT_STUDY: '*Current Study',
  CLASS_RANKING: 'Class Ranking:',
};

export const PANEL_DETAIL_MEMBER_TEXT = {
  NUMBER: '#',
  NETID: 'NetID',
  NAME: 'Name',
  DEP: 'Dept.',
  EMAIL: 'E-mail',
  DISCIPLINES: 'Disciplines',
  ACTION: 'Action',
};

export const PANEL_RESULT_OPTION_TEXT = {
  SET_RESULT_OPTION: 'Set Result Option',
  CREATE_RESULT_OPTION: 'Create result option',
  CREATE_NEW_RESULT_OPTION: 'Create a new result option',
};

export const PANEL_TAG_TEXT = {
  SET_TAGS: 'Set Tags',
  CREATE_PANEL_TAG: 'Create panel tag',
  CREATE_NEW_PANEL_TAG: 'Create a new panel tag',
};

export const PANEL_FORM_DIALOG_TEXT = {
  PANEL_SETTING: 'Panel Setting',
  PANEL_INFORMATION: 'Panel Information',
  PANEL_NO: 'Panel No.',
  ENTRY_YEAR: 'Entry Year',
  ROUND_TITLE: 'Round Title',
  FUNDING: 'Funding',
  DISCIPLINES: 'Disciplines',
  START_TIME: 'Start Time',
  END_TIME: 'End Time',
  PANEL_CHAIR: 'Panel Chair',
  CHAIR_MARK: '* : Panel Chair',
  APPLICATION_NO: 'Application No.',
  APPLICATION_NAME: 'Application Name',
  ADD_MEMBER: 'Add Member:',
  ADD_APPLICANT: 'Add Applicant:',
  PANEL_MEMBER: 'Panel Memeber',
  GS_HELPER: 'GS Helper',
  TAGS: 'Tags',
  CREATE_PANEL: 'Save Panel',
  REMOVE_WARNING:
    'Warning: It will affect the nomination / assessment / selection functions!',
  EDIT: 'Edit',
  CREATE: 'Create',
  SAVE: 'Save',
  CLOSE: 'Close',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  SUMMARY_TABLE: 'Summary Table',
  PARTNER_SUMMARY_TABLE: 'Partner Summary Table',
  CONFIRM_ADD:
    'Please confirm to add this applicant into the application list:',
  NOTE: 'Notification',
  ANNOUNCE:
    'Do you confirm the announcement of the results for this panel? Once announced, the shortlisted applications will be forwarded to their respective supervisors and DoRPgSs for further processing. Please be advised that this action is irreversible.',
};

export const PANEL_LIST_SETTING_DIALOG_TEXT = {
  LIST_SETTING: 'List Setting',
  LIST_NAME: 'List Name',
  CONDITIONS: 'Conditions',
  TAGS_LIST: 'Tags List',
  DELETE_LIST: 'Delete List?',
  CREATE: 'Create',
  UPDATE: 'Update',
  CANCEL: 'Cancel',
};

export const PANEL_APPLICATION_SELECTION_TEXT = {
  NUMBER: '#',
  APPLICATION_NO: 'Application No.',
  NAME: 'Name',
  DEPARTMENT: 'Prog. Dept.',
  PANEL: 'Panel',
  APPLICATION_DETAILS: 'Application Details',
  SCHEMES: 'Schemes',
  TOTAL_SCORE: 'Total Score',
  RESULT: 'Result',
  FIRST_DEGREE: 'First Degree',
  CONVERTED_GPA_CLASS_RANKING_FIRST_CLASS_HONOURS:
    'GPA | Class Ranking | First Class Honours',
  PUBLICATIONS: 'Publications',
  MERIT: 'merit',
  MASTER_DEGREE: 'Master Degree',
  TAGS: 'Tags',
  VIEW: 'View',
};

export const PANEL_APPLICATION_REVIEWER_TEXT = {
  APPLICATION_REVIEW: 'Application Review',
  PROFILE: 'Application Particulars - ',
  REVIEW_GUIDANCE:
    'Please review the rating of each aspect. If you disagree with the rating(s) given by the Department/School, please update your rating in the column “Amended Rating” and provide your comments in the textbox.  Click “confirm” after your evaluation.',
  AE: 'Academic Excellence',
  RP: 'Research Ability',
  RP_TOOLTIP: 'Research Ability and Potential',
  LS: 'Leadership Societal',
  LS_TOOLTIP: 'Leadership Ability and Societal Responsibility',
  CI: 'Communication',
  CI_TOOLTIP: 'Communication and Interpersonal Skills',
  RE: 'Resilience Capability',
  OS: 'Organization Skills',
  CD: 'Culture Diversity',
  US: 'University Support',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  DEPT_RATING: 'Dept. Rating',
  AMENDED_RATING: 'Amended Rating',
  COMMENT: 'Comment',
  AMEND_RATING_SUCCESS: 'Amended Rating Successfully',
  REVIEW_DETAILS: 'Review Details',
};
